module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/customize_tablet-8cc46d37ed0d81cedfdaa89fd2c48e90.png";